module.exports = __webpack_public_path__ + "img/messagegray.afb5faba.svg";